var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHowIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 9.1665L9.99935 6.6665L13.3327 9.99984L9.99935 13.3332V10.8332L6.66602 10.8332V9.1665H9.99935ZM9.99935 1.6665C14.5993 1.6665 18.3327 5.39984 18.3327 9.99984C18.3327 14.5998 14.5993 18.3332 9.99935 18.3332C5.39935 18.3332 1.66602 14.5998 1.66602 9.99984C1.66602 5.39984 5.39935 1.6665 9.99935 1.6665ZM9.99935 16.6665C13.6827 16.6665 16.666 13.6832 16.666 9.99984C16.666 6.3165 13.6827 3.33317 9.99935 3.33317C6.31602 3.33317 3.33268 6.3165 3.33268 9.99984C3.33268 13.6832 6.31602 16.6665 9.99935 16.6665Z",
    fill: "#909CBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowIcon);
export default __webpack_public_path__ + "static/media/HowIcon.24539857f98ef1d10d6bb73bda3a781f.svg";
export { ForwardRef as ReactComponent };